import React from "react";

function Icon(props) {
  return (
      <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 225 224"
            style={props.style}
            className={props.svgClass}
        >
        <path
            fill={props.color ? props.color : "#1EAC5F"}
            d="M18752 3361.22c13.4-13.37 141.7-141.66 141.7-141.66 2.5-2.48 2.5-6.49 0-8.97l-14.4-14.39a6.374 6.374 0 00-9 0l-122.7 122.74-50.7-50.7a6.374 6.374 0 00-9 0l-14.4 14.39c-2.4 2.48-2.4 6.49 0 8.97 0 0 60.6 60.58 69.6 69.62 1.2 1.17 2.8 1.84 4.5 1.84 1.7 0 3.2-.67 4.4-1.84z"
            transform="matrix(.99996 0 0 1.00134 -18670.7 -3171.47)"
        ></path>
        <path
            fill="none"
            d="M4994.62 5721.16H5374.557V6147.098H4994.62z"
            transform="matrix(.5902 0 0 .52566 -2947.81 -3007.4)"
        ></path>
        </svg>
    </div>
  );
}

export default Icon;
